import styled from 'styled-components';
import { Drawer } from 'antd';
import Colors from '@/constants/Colors';
const titleIconSize = 24;
export const minWidth = '33%';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    min-width: 33%;
  }

  .ant-drawer-header {
    padding-bottom: 0;
    border: none;
  }

  .ant-drawer-header-title {
    flex-direction: row-reverse;
    padding-bottom: 16px;
    border-bottom: 1px solid ${Colors.text}4D;

    button {
      margin-right: 0;
    }

    .title {
      text-transform: capitalize;
    }

    .title-with-icon {
      display: flex;
      align-items: center;
      height: ${titleIconSize}px;

      .title-icon {
        font-size: ${titleIconSize}px;
        padding-bottom: 4px;
        margin-right: 8px;

        &.not-allowed {
          color: ${Colors.red};
        }
      }
    }
  }

  .ant-drawer-body {
    display: flex;
    flex-direction: column;

    .ant-alert {
      margin-top: 20px;
    }

    .drawer-spinner {
      display: flex;
      flex-grow: 1;

      > .ant-spin-container {
        display: flex;
        flex-grow: 1;
      }
    }
  }

  .has-error > * {
    border: 1px solid ${Colors.red};
    border-radius: 3px;
  }

  .ant-space {
    width: 100%;
  }

  .main-content {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 20px;
  }
`;
